import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Toastify } from "../../../components/Toaster";

export interface Integration {
  IntegrationName: string;
  DisplayIntegrationName: string;
  Categories: string[];
  IsConfigurable: boolean;
  IsCustom: boolean;
}

export interface IntegrationListState {
  Data: Integration[];
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  errorMessage: string | null;
}

// export interface IntegrationSchema {
//   integrationList: IntegrationListState;
// }

const initialState: IntegrationListState = {
  Data: [],
  isLoading: false,
  isSuccess: false,
  isError: false,
  errorMessage: null
};

interface GetIntegrationListAPIResponse {
  Data: Integration[];
  errorCode?: number;
  message?: string;
  description?: string;
}

export const IntegrationListSlice = createSlice({
  name: "integrationList",
  initialState,
  reducers: {
    getIntegrationListRequest(state) {
      state.isLoading = true;
      state.isSuccess = false;
      state.isError = false;
      state.errorMessage = null;
    },
    getIntegrationListSuccess(state, action: PayloadAction<GetIntegrationListAPIResponse>) {
      state.isLoading = false;
      state.isSuccess = true;
      state.Data = action.payload.Data;
    },
    getIntegrationListFailure(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.payload;
      Toastify("error", action.payload);
    }
  }
});

export const { getIntegrationListRequest, getIntegrationListSuccess, getIntegrationListFailure } = IntegrationListSlice.actions;
